import React from 'react'
import formStyles from './styles/forms.module.scss'
import { SexEnum } from 'types/api/enums'
import RadioFieldWTN from './RadioFieldWTN'
import { ErrorMessage } from 'formik'
import { useFormLabels } from 'forms/common/translations'

interface Props {
  formikName: string
  isDisabled?: boolean
}

const SexInputGroup = ({ formikName, isDisabled = false }: Props) => {
  const labels = useFormLabels()
  return (
    <>
      <div role='group' aria-labelledby={formikName}>
        <RadioFieldWTN
          name={formikName}
          value={SexEnum.M}
          text={labels.male}
          disabled={isDisabled}
        />
        <RadioFieldWTN
          name={formikName}
          value={SexEnum.F}
          text={labels.female}
          disabled={isDisabled}
        />
      </div>
      <ErrorMessage name={formikName} component='div' className={formStyles.errorMessage} />
    </>
  )
}

export default SexInputGroup
